<script lang="ts">
    import FieldHeading from './field-heading.svelte'
    import TinyEditor from '../tiny-editor.svelte'
    import { sanitizeHtml } from '../../utils/sanitize-html'

    export let label: string
    export let data: Record<string, any>
    export let value: string = ''
    export let required = false
    export let readOnly = false

    $: isEmpty = !value || value.replace(/<[^>]*>/g, '').trim() === ''
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    {#if readOnly}
        {#if isEmpty}
            <div class="view-html empty">—</div>
        {:else}
            <div class="view-html">{@html sanitizeHtml(value)}</div>
        {/if}
    {:else}
        <div class="rich-editor">
            <TinyEditor bind:value />
        </div>
    {/if}
</div>

<style>
    .view-field {
        width: 100%;
    }
    .rich-editor {
        /* max-width: 640px; */
    }
    .view-html {
        font-size: 0.92rem;
        color: #495057;
        line-height: 1.5;
    }
    .view-html.empty {
        color: #868e96;
    }
    .view-html :global(p) {
        margin: 0 0 8px;
    }
    .view-html :global(p:last-child) {
        margin-bottom: 0;
    }
    .view-html :global(ul),
    .view-html :global(ol) {
        margin: 0 0 8px;
        padding-left: 22px;
    }
    /* Ver label-view.svelte: imagem do editor vem sem dimensão e ia para o layout no tamanho
       natural. `:global` porque conteúdo de {@html} não recebe a classe de escopo do Svelte. */
    .view-html :global(img) {
        max-width: 100%;
        height: auto;
    }
    .view-html :global(a) {
        color: var(--cs2-accent, #4263eb);
        text-decoration: underline;
    }
    .view-html :global(table) {
        border-collapse: collapse;
        margin: 8px 0;
    }
    .view-html :global(table td),
    .view-html :global(table th) {
        border: 1px solid #dee2e6;
        padding: 6px 10px;
    }
</style>
